import store from "../redux/store";
import * as actionTypes from '../redux/constants';

const SESSION_TIMEOUT_WARNING = 55 * 60 * 1000;

const sessionTimerObj = () => {
    let timerId = null;

    sessionTimerObj.prototype.reset = () => {

        if (timerId !== null) {
            clearTimeout(timerId);
        }

        timerId = setTimeout(() => {

            store.dispatch({
                type: actionTypes.SHOW_TIMEOUT_MODAL
            });

        }, SESSION_TIMEOUT_WARNING);
    };

    sessionTimerObj.prototype.stop = () => {
        if (timerId !== null) {
            console.log("Session Timer Stop");
            clearTimeout(timerId);
        }
    };
};

const sessionTimer = new sessionTimerObj();

document.addEventListener("keydown", sessionTimer.reset);
document.addEventListener("mousedown", sessionTimer.reset);

export default sessionTimer;